<template>
  <div class="dialog-confirm" :class="{ 'is-bottom-sheet': isBottomSheet }">
    <div class="text-center">
      <span v-if="header" class="f-bold f-body-lg">{{ header }}</span>
      <p v-if="text" class="text-text f-title-sm mt-3" v-html="text"></p>
      <div v-if="subText" class="text-sub f-body" v-html="subText"></div>
    </div>

    <hr v-if="!isBottomSheet" />

    <div class="text-center mt-3">
      <c-btn
        variant="confirm-primary"
        block
        @click="$emit('confirm')"
        data-test="modal-confirm-button"
      >
        {{ button.true.msg }}

      </c-btn>
      <c-btn
        variant="outline-primary"
        class="mt-3"
        block
        @click="$emit('cancel')"
        data-test="modal-cancel-button"
      >
        {{ button.false.msg }}
      </c-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "DialogConfirm",
  emits: ["confirm", "cancel"],
  props: {
    header: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    subText: {
      type: String,
      default: ""
    },
    button: {
      type: Object,
      default: () => ({
        true: { msg: $t("confirm"), class: ["btn-success"] },
        false: { msg: $t("cancel"), class: ["btn-danger"] }
      })
    },
    contentClass: {
      type: String,
      default: ""
    },
    isBottomSheet: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
.dialog-confirm {
  // padding: 24px 16px;

  &.is-bottom-sheet {
    // padding: 32px 16px 24px;
  }
}

.text-text {
  margin-bottom: 0;
  word-wrap: break-word !important;
}

.text-sub {
  color: var(--font-color);
  word-wrap: break-word !important;
}

hr {
  margin: 16px 0;
  border: none;
  border-top: 1px solid var(--divider-color, #e0e0e0);
}
</style>
